import { ChatBubbleLeftIcon, HeartIcon } from '@heroicons/react/24/solid';
import cx from 'classnames';

import type { Post } from '~/interfaces/post';

import Typography from '../Typography';

const CountWrapper = ({
  count,
  children,
  className,
  color,
  fontFamily,
}: {
  count: number;
  className?: string;
  children: React.ReactNode;
  color?: string;
  fontFamily?: string;
}) => {
  return (
    <Typography
      size="sm"
      as="span"
      fontFamily={fontFamily}
      fontFamilyv2={fontFamily}
      className={cx(className, 'flex items-center space-x-0.5')}
      color={color}
      weight="regular"
    >
      {children}
      {count > 0 ? <span className="text-xs font-bold">{count}</span> : null}
    </Typography>
  );
};

interface Props {
  post: Post;
  color?: string;
}

const PostInsights = ({ post, color }: Props) => {
  const likeCount = post?.likes?.length || 0;
  const commentCount = post?.comment_count || 0;

  return (
    <div className="flex items-center space-x-3">
      <CountWrapper count={likeCount} color={color}>
        <HeartIcon className="h-4 w-4" />
      </CountWrapper>
      {post.comments_enabled && (
        <CountWrapper count={commentCount} color={color}>
          <ChatBubbleLeftIcon className="h-4 w-4" />
        </CountWrapper>
      )}
    </div>
  );
};

export default PostInsights;
